import * as _ from 'lodash';
import { CreditRequirements } from '../../../../ng2/shared/constants/credit-requirements.constant';

angular.module('nv.shared.modals').factory('CreditGapConfirmDropModal', CreditGapConfirmDropModal);

function CreditGapConfirmDropModal($mdDialog) {
  return {
    show(courseName, gradReqs, creditValue) {
      const netGapsText = creditValue !== 1 ? 'gaps' : 'gap';
      const gradReqsLength = gradReqs.length;
      let gradReqsText = '';

      function formatGradReqHuman(gradReq) {
        if (gradReq.human === CreditRequirements.TOTAL.human) {
          return '44 Req';
        }
        return gradReq.human;
      }

      if (gradReqsLength === 1) {
        gradReqsText = gradReqs[0].human;
      } else if (gradReqsLength === 2) {
        gradReqsText = `${formatGradReqHuman(gradReqs[0])} and ${formatGradReqHuman(gradReqs[1])}`;
      } else if (gradReqsLength > 2) {
        _.each(gradReqs, (gradReq, index: number) => {
          if (index !== gradReqsLength - 1) {
            gradReqsText += `${formatGradReqHuman(gradReq)}, `;
          } else {
            gradReqsText += `and ${formatGradReqHuman(gradReq)}`;
          }
        });
      }

      const confirm = $mdDialog
        .confirm()
        .title('Confirm Drop')
        .textContent(
          `Dropping ${courseName} will result in ${creditValue} new credit ${netGapsText}
          in ${gradReqsText}. Are you sure you want to drop it?`,
        )
        .css('credit-gap-confirm-drop')
        .ariaLabel('Confirm drop modal')
        .ok('DROP')
        .cancel('CANCEL');

      return $mdDialog.show(confirm);
    },
  };
}
